import { initialize, LDClient, LDContext } from 'launchdarkly-js-client-sdk';
import { IFeatureStoreConfig } from '../../models/IFeatureStoreConfig';

let ldClient: LDClient;

class SunbitFeatureStore {
  async initFeatureStore(config: IFeatureStoreConfig) {
    if (!ldClient) {
      const context: LDContext = {
        kind: config.kind,
        key: config.contextKey,
      };
      ldClient = initialize(config.envKey, context);
      await ldClient.waitUntilReady();
    }
  }

  getFeatureFlagValue(flagName: string) {
    const flagValue = ldClient.variation(flagName, false);
    return flagValue;
  }
}

export const sunbitFeatureStore = new SunbitFeatureStore();
